export default {
    computed: {
        isBlogPage() {
            return this.cmsPageState?.currentPage?.type ?? '' === 'cms_blog';
        },
    },

    methods: {
        createdComponent() {
            this.initElementConfig('acris-blog-image');

            if (!this.isBlogPage || this.element?.translated?.config?.media) {
                return;
            }

            if (this.element.config.media.source && this.element.config.media.value) {
                return;
            }

            this.element.config.media.source = 'mapped';
            this.element.config.media.value = 'acris_blog.media';
        }
    }
};